<template>
    <div>
        <div class="tit-wrap">
            <h3 class="tit top-line-tit">Middle East</h3>
        </div>

        <v-data-table
            :headers="headers"
            :items="items"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            mobile-breakpoint="0"
            @page-count="pageCount = $event"
            class="v-data-table--default v-data-table--no-active"
        ></v-data-table>

        <div class="v-pagination-wrap text-center">
            <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                { text: "P/J Name", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "Client", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "End-User", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "Year", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "Description", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [
                {
                    name: "Basrah Project, Iraq",
                    client: "HDEC",
                    user: "South Refineries Company (SRC)",
                    year: "2022",
                    description: "Manual Sampling System",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "HDEC",
                    user: "KIPIC",
                    year: "2018",
                    description: "O2 Analyzer Package",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "Emerson",
                    user: "SCOP",
                    year: "2018",
                    description: "Metering GC Analyzer Package",
                },
                {
                    name: "Al-Zour Refinery Project, Kuwait",
                    client: "HDEC",
                    user: "KIPIC",
                    year: "2017",
                    description: "Chlorine Analyzer with Local Rack",
                },
                {
                    name: "EDRF, Saudi",
                    client: "HDEC/ISG",
                    user: "Saudi Aramco",
                    year: "2017",
                    description: "Analyzer Package",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "Honeywell",
                    user: "KIPIC",
                    year: "2017",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "HEC",
                    user: "KIPIC",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Al-Zour Refinery Project, Kuwait",
                    client: "Saipem",
                    user: "KIPIC",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "CFP Project, Kuwait",
                    client: "SKEC",
                    user: "KNPC",
                    year: "2016",
                    description: "AAQMS Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "HDEC",
                    user: "SCOP",
                    year: "2015",
                    description: "AAQMS Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "HDEC",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter (included CEMS)",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "GS E&C",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "SKEC",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Jazan Refinery & Terminal Project, Saudi Arabia",
                    client: "SKEC",
                    user: "Aramco Overseas Company B.V",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "ERC Refinery Project, Egypt",
                    client: "GS E&C",
                    user: "Egyptian Refining Company S.A.E",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "SADARA Project, Saudi Arabia",
                    client: "eTEC",
                    user: "SABIC",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "MGP Project, Oman",
                    client: "HDEC",
                    user: "OOCEP",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "KOTC Um Aish New Filling Plant Projct, Kuwait",
                    client: "HENC",
                    user: "KOC&nbsp;",
                    year: "2012",
                    description: "Dew Point Analyzer system",
                },
                {
                    name: "LBO Project, UAE",
                    client: "HDEC",
                    user: "Takreer",
                    year: "2011",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "KOTC Um Aish New Filling Plant Projct, Kuwait",
                    client: "HENC",
                    user: "KOC&nbsp;",
                    year: "2012",
                    description: "Dew Point Analyzer system",
                },
                {
                    name: "Yanbu Export Refinery Project (PKG 2), Saudi Arabia",
                    client: "SKEC",
                    user: "Saudi Aramco",
                    year: "2012",
                    description: "Analyzer Package System",
                },
                {
                    name: "KOC Pipeline Project, Kuwait",
                    client: "HDEC",
                    user: "KOC&nbsp;",
                    year: "2011",
                    description: "Analyzer w/Shelter",
                },
                {
                    name: "BS-132 Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2011",
                    description: "Process Analyzer System",
                },
                {
                    name: "SKIKDA Refinery Project, Algeria",
                    client: "Green Entech",
                    user: "SONATRACH",
                    year: "2010",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "KOC GC#24 Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2009",
                    description: "DO, Density analyzer system",
                },
                {
                    name: "DHT Project, Saudi",
                    client: "SECL",
                    user: "Saudi Aramco",
                    year: "2009",
                    description: "Field analyzer system",
                },
                {
                    name: "KPPC Aromatics Complex Project, Kuwait",
                    client: "Tecnimont S.p.A",
                    user: "Kuwait Paraxylene Production Company",
                    year: "2007",
                    description: "O2 Analyzer",
                },
                {
                    name: "KPPC Aromatics Complex Project, Kuwait",
                    client: "SKEC",
                    user: "Kuwait Paraxylene Production Company",
                    year: "2007",
                    description: "O2/ Density/ Mositure/ HC/ NIR and RVP Analyzer",
                },
                {
                    name: "KOC FMP Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2006",
                    description: "HC Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "IZMR.DHP Project, Turkey",
                    client: "KAS System Co., Ltd.",
                    user: "Tupras Corp.",
                    year: "2006",
                    description: "H2, Portable O2 Analyzer system",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
